/**
* @Author: zachalam
* @Date:   2017-03-15T16:33:24-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-03-15T16:33:24-07:00
*/


import React, { Component } from 'react';
import Photos from '../components/pages/Photos/Photos';
import { connect } from 'react-redux';
import { deletePhoto, makePhotoDefault, removePhoto,
  setNewPrivacy, addNewPhoto, refreshProfile } from '../actions/profileActions';

class PhotosContainer extends Component {

  componentWillMount() {
    this.props.refreshProfile();
  }

  render() {
    return (
      <Photos {...this.props} />
    );
  }
}


const mapStateToProps = (state) => {
  return {
    photos: state.profile.photo,
    username: state.profile.username
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    uploadPhoto: (formData) => {
      dispatch(addNewPhoto(formData));
    },
    deletePhoto: (photoId,photoKey) => {
      //console.log("key we got", photoKey);
      // remove photo from API.
      dispatch(deletePhoto(photoId));
      // remove from store.
      dispatch(removePhoto(photoKey));
    },
    setPrivacy: (photoId,photoKey) => {
      // swaps photo privacy.
      dispatch(setNewPrivacy(photoId,photoKey));
    },
    makeDefault: (photoId,photoKey) => {
      // makes photo your default
      dispatch(makePhotoDefault(photoId,photoKey));
    },
    refreshProfile: () => {
      dispatch(refreshProfile())
    },
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(PhotosContainer);



// WEBPACK FOOTER //
// ./src/containers/PhotosContainer.jsx